<template>
<div class="writecard table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">空中写号记录</span>
        <el-form inline class="hook right themed-form search-form" v-model="form" style="line-height: 40px;">
            <el-form-item label="EID:">
                <el-input v-model="form.eid" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="旧ICCID:">
                <el-input v-model="form.oldIccid" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="原接入号:">
                <el-input v-model="form.oldMsisdn" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="ICCID:">
                <el-input v-model="form.newIccid" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="接入号:">
                <el-input v-model="form.newMsisdn" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="状态:">
                <el-select v-model="form.status" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="写号中" value="0"></el-option>
                    <el-option label="已写号" value="1"></el-option>
                    <el-option label="写号失败" value="2"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="开始时间:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.startTime" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item label="结束时间:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.endTime" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">查询</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-back" class="themed-button" @click="exportExcel">导出</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="importData">导入</el-button>
            </el-form-item>
        </el-form>
    </div>
    
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
            <el-table-column label="EID" prop="eid" show-overflow-tooltip></el-table-column>
            <el-table-column label="原接入号" prop="oldMsisdn" show-overflow-tooltip></el-table-column>
            <el-table-column label="旧ICCID" prop="oldIccid" show-overflow-tooltip></el-table-column>
            <el-table-column label="新接入号" prop="newMsisdn" show-overflow-tooltip></el-table-column>
            <el-table-column label="新ICCID" prop="newIccid" show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" prop="status" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatStatus(scope.row.status) }}
                </template>
            </el-table-column>
            <el-table-column label="操作人" prop="operatorName" show-overflow-tooltip></el-table-column>
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.createTime) }}
                </template>
            </el-table-column>
        </el-table>
    </div>
    
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[15, 30, 50, 100]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <!-- 导入弹框 -->
    <el-dialog title="批量导入" :visible.sync="importDialogVisible" width="600px">
        <el-form label-position="right" label-width="180px" style="max-height:500px;overflow:auto">
            <el-form-item label="上传文件（excel）:" required>
                <input class="file-input" type="file" ref='importFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
            <el-form-item label="设备卡信息:">
                <el-input v-model="importCardInfo" type="textarea" rows="6" placeholder="请输入EID 新ICCID 新接入号 ，每行一组，用空格分开"></el-input>
                <div style="color:#f00;">请输入EID  新ICCID  新接入号 ，每行一组，用空格分开</div>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitImport">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="importDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { 
    listWriteCard, 
    exportWriteCardSync, 
    importExcel
} from '@/api/writeCardManagement/writecard.js'
import { messageBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'
import Utils from '@/utils/utils.js'
import {exportTemplate} from '@/api/statistics.js'

export default {
    name: 'writecard',
    mixins: [resize],
    data() {
        return {
            form: {
                eid: '',
                oldIccid: '',
                oldMsisdn: '',
                newIccid: '',
                newMsisdn: '',
                status: '',
                startTime: '',
                endTime: ''
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,

            // 状态映射
            statusMap: {
                0: '写号中',
                1: '已写号',
                2: '写号失败'
            },

            // 导入弹框数据
            importDialogVisible: false,
            importCardInfo: ''
        }
    },
    mounted() {
        this.getList()
    },
     activated() {
    this.getList()
  },
    methods: {
        // 获取列表数据
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form
            }
            
            listWriteCard(params).then(res => {
                if (res && res.page) {
                    this.tableData = res.page.rows || []
                    this.total = res.page.total || 0
                }
            })
        },

        // 搜索
        searchData() {
            this.currentPage = 1
            this.getList()
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getList()
        },

        // 导出
        exportExcel() {
            exportWriteCardSync(this.form).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert('导出成功，请到导出记录中下载', '提示', {
                        confirmButtonText:'确定',
                    }).then(() => {
                        this.$router.push('/tob/i_export_list')
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 导入操作
        importData() {
            this.importDialogVisible = true
        },

        // 提交导入
        submitImport() {
            let file = this.$refs['importFile'].files[0];
            let formData = new FormData();
            
            // 处理卡信息
            if (!file && !this.importCardInfo.trim()) {
                messageBox(this, '请选择文件或输入号卡信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', file);
            }
            
            // 无论是否有文件，都添加卡信息到表单
            formData.append('phones', this.importCardInfo);
            
            importExcel(formData).then(res => {
                if (res.system_result_key == '0') {
                    if (file) {
                        // 有Excel文件上传，跳转到导入记录页面
                        this.$alert(res.system_result_message_key || '导入成功，请到导入记录中下载', '提示', {
                            confirmButtonText: '确定',
                        }).then(() => {
                            this.$refs['importFile'].value = '';
                            this.importCardInfo = '';
                            this.importDialogVisible = false;
                            this.$router.push('/tob/i_import_list');
                        })
                    } else {
                        // 无Excel文件上传，只刷新当前列表
                        this.$message({
                            showClose: true,
                            message: res.system_result_message_key || '导入成功',
                            type: 'success'
                        });
                        this.importCardInfo = '';
                        this.importDialogVisible = false;
                        this.getList(); // 刷新列表数据
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 导出模板
        exportTemplate() {
            exportTemplate({name: 'importWriteCard.xls'}).then(res => {
                const filename = 'importWriteCard.xls'
                Utils.createDownload(res, filename)
            })
        },

        // 格式化状态
        formatStatus(status) {
            return this.statusMap[status] || '未知状态'
        },
        
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            
            try {
                
                
                // 处理ISO格式的时间字符串
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;
                
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error('日期格式化错误:', error);
                return dateTime;
            }
        }
    }
}
</script>

<style scoped>
.writecard {
    padding: 20px;
}



.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}

.file-input {
    display: inline-block;
}

.mt5 {
    margin-top: 5px;
}

.align-right {
    text-align: right;
    margin-top: 20px;
}

.text-color {
    color: #606266;
}

.info-box {
    padding: 10px;
    background-color: #f0f0f0;
    border-radius: 4px;
}
</style> 